import React from "react";

const PrimaryButton = ({ title, onClick }) => {
    return (
        <div className="container mt-4">
            <button onClick={onClick} className="btn btn-primary">{title}</button>
        </div>
    );
};

export default PrimaryButton;
